import { render } from "./AproModal.vue?vue&type=template&id=ddc71ca0"
import script from "./AproModal.vue?vue&type=script&lang=ts"
export * from "./AproModal.vue?vue&type=script&lang=ts"

import "./AproModal.vue?vue&type=style&index=0&id=ddc71ca0&lang=css"
script.render = render

export default script